import { RootState } from "../../store";

export const pollingInterruptedSelector = (state: RootState): boolean =>
  state.accountSetup.pollingInterrupted;
